export default __webpack_public_path__ + "images/a019d847-logo-100x22-white.svg";